import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const MainLayout = ({ children }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const location = useLocation();
  
  // Definir a aba ativa com base na URL
  useEffect(() => {
    const path = location.pathname;
    
    if (path.includes('/dashboard')) {
      setActiveTab('dashboard');
    } else if (path.includes('/sales') || path === '/virtual-model') {
      setActiveTab('sales');
    } else if (path.includes('/inventory')) {
      setActiveTab('inventory');
    } else if (path.includes('/financial')) {
      setActiveTab('financial');
    } else if (path.includes('/reports')) {
      setActiveTab('reports');
    }
  }, [location.pathname]);
  
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header activeTab={activeTab} setActiveTab={setActiveTab} />
        
        <main className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {children}
        </main>
        
        <footer className="bg-white border-t border-gray-200 p-4">
          <div className="text-center">
            <p className="text-sm text-gray-500">© 2025 Resort Surfland Brasil - Plataforma de Vendas de Multipropriedade v2.3.5</p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;